import { createPortal } from 'react-dom';
import { useEffect, useState, memo } from 'react';

const Portal = memo(({ children }) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  if (!mounted) return null;
  return createPortal(<div data-portal>{children}</div>, document.body);
});

Portal.nomeExibicao = 'Portal';

export default Portal;
